/* eslint-disable no-console */

import { storageCanBeSet as pecrStorageCanBeSet } from 'pecr-util';
import storageManifestJson from '../../../../../storageManifest.json';

export function checkSessionStorage() {
  if ('sessionStorage' in window) {
    try {
      const testKey = 'v6rVO950aw8nBaU';
      sessionStorage.setItem(testKey, testKey);
      sessionStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  } else {
    // console.error('No access to sessionStorage');
    return false;
  }
}

export function checkLocalStorage() {
  if ('localStorage' in window) {
    try {
      const testKey = 'IyagUtLwb8jef9k';
      localStorage.setItem(testKey, testKey);
      localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  } else {
    // console.error('No access to localStorage');
    return false;
  }
}

export const storageCanBeSet = (storageType = 'cookie', storageKey = 'recentlyViewedItems', manifest) => {
  const storageManifest = manifest || storageManifestJson
  const acceptedStorageTypes = ['cookie', 'localStorage', 'sessionStorage'];
  const isTestEnv = process.env.NODE_ENV === 'test';
  if (!storageManifest) {
    if (!isTestEnv) {
      console.group('🍪  Cookies 🍪');
      console.warn('Storage manifest file does not exist');
      console.warn('Have you run "./go refresh-templates"?');
      console.groupEnd();
    }
    return false;
  }
  if (!acceptedStorageTypes.includes(storageType)) {
    if (!isTestEnv) {
      console.group('🍪  Cookies 🍪');
      console.warn(`Wrong storage type requested: ${storageType}`);
      console.warn(`It needs to be one of ${acceptedStorageTypes.toString()}`)
      console.groupEnd();
    }
    return false;
  }
  if (!storageManifest[storageType][storageKey]) {
    if (!isTestEnv) {
      console.group('🍪  Cookies 🍪');
      console.warn(`${storageType}.${storageKey} doesn't exist in the Storage Manifest: app/src/main/resources/storageManifest.json`);
      console.groupEnd();
    }
    return false;
  }
  const { [storageType]: { [storageKey]: foundStorageKey = undefined } } = storageManifest;
  const canPecrStorageBeSet = pecrStorageCanBeSet(foundStorageKey)
  if (!foundStorageKey || !canPecrStorageBeSet) return false;
  return true;
}
